import React from 'react';
import { components } from 'react-select';

import CheckboxMarker from 'components/Checkbox/CheckboxMarker';


function Option(props) {
  const { innerRef, innerProps, isSelected, isMulti, label, isDisabled, limitNumber, selectProps, value, isSimple, data: { hasParentId, is_other } } = props;
  const isLimited = limitNumber === selectProps?.value?.length;

  const showValue = () => {
    if (is_other) {
      const splitValue = label.split('-');
      return splitValue[1];
    }
    return label
  }

  if (isMulti) {
    return (
      <>
        {
          isDisabled
            ? <components.Option {...props} />
            : isLimited && selectProps.value && !selectProps.value.find(valueItem => valueItem.value === value)
              ? <components.Option {...props} isDisabled={true} />
              : <div
                ref={innerRef}
                {...innerProps}
                className="option-container"
              >
                {hasParentId && <span style={{ marginLeft: 20 }} />}
                <CheckboxMarker isChecked={isSelected} className="select__check-marker" />
                <span className="option-label">
                  {showValue()}
                </span>
              </div>
        }
      </>
    )
  }

  if (isSimple && hasParentId) {
    return (
      <>
        {
          isDisabled
            ? <components.Option {...props} isDisabled={true} />
            : <div
              ref={innerRef}
              {...innerProps}
              className="option-container option-container__withline"
            >
              <span>-&nbsp;</span>
              <span className="option-label">
                {showValue()}
              </span>
            </div>
        }
      </>
    )
  }

  return <components.Option {...props} />;
}


export default Option;
